import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { map } from 'lodash';

import { SidebarItem } from './SideBarItem';
import useWorkflowsStore from 'models/workflows/workflows.store';
import { Label } from 'models/workflows/workflows.types';
import { getRouteKey } from 'utils/workflows';
import CONST from 'utils/constants';

const { MENU_APP_SOURCES } = CONST;

const renderSidebarItem = (
  currentRouteKey: string,
  label: Label,
  marketplaceKey: string,
  iconPath: string,
  appSource: string,
  key: string,
) => {
  const routeKey = `route-${marketplaceKey}`;
  const to =
    appSource === MENU_APP_SOURCES.CUSTOM_FLOW
      ? `/flow/${marketplaceKey}`
      : `/work/${marketplaceKey}`;
  return (
    <SidebarItem
      key={key}
      isSelected={currentRouteKey === routeKey}
      text={`${label?.en}`}
      iconPath={iconPath}
      to={to}
    />
  );
};

const DynamicSideBar = () => {
  const location = useLocation();
  const [currentRouteKey, setCurrentRouteKey] = useState('');
  const { dynamicMenu } = useWorkflowsStore();

  useEffect(() => {
    setCurrentRouteKey(getRouteKey());
  }, [location]);

  return (
    <React.Fragment>
      {/* DYNAMIC MENU ITEMS */}
      {map(dynamicMenu, (item, key) =>
        renderSidebarItem(
          currentRouteKey,
          item.label,
          item.marketplaceKey,
          item.icon,
          item.appSource,
          String(key),
        ),
      )}
    </React.Fragment>
  );
};

export default DynamicSideBar;
